import {IDataSourceAdapter} from '~/lib/dataSource';
import {copyAgency, copyBidder, createBidder, deleteBidder, updateBidder} from '~/modules/Bidders/api';
import {IBidder} from '~/modules/Bidders/models/Bidder';
import {
    createAgency,
    createSeller,
    deleteAgency,
    deleteSeller,
    fetchAgencies,
    fetchAgencyBidders,
    fetchSellers,
    fetchSellerSources,
    fetchSellerFinanceTransactions,
    updateAgency,
    updateSeller,
    fetchSellerBlockings,
    updateBlocking,
    createBlocking,
    deleteBlocking,
    fetchLines, createLine, updateLine, deleteLine
} from '~/modules/Clients/api';


import {IAgency} from '~/modules/Clients/models/Agency';
import {IBlocking} from '~/modules/Clients/models/Blocking';
import {IAgencyBiddersFilter, ISellerBlockingsFilter, ISellerSourcesFilter, ISellerFinanceFilter} from '~/modules/Clients/models/filters';
import {ISeller} from '~/modules/Clients/models/Seller';
import {
    createSource,
    deleteSource, updateLimitedSource,
    updateSource
} from '~/modules/Sources/api';
import {ISource} from '~/modules/Sources/models/Source';
import {IFinanceTransaction, ITransaction} from '~/modules/Clients/models/Finance';
import { ILine } from "./models/Line";

export const agenciesAdapter: IDataSourceAdapter<IAgency> = {
    fetchRecords: fetchAgencies,
    createRecord: createAgency,
    updateRecord: updateAgency,
    copyRecord: copyAgency,
    deleteRecord: deleteAgency
};

export const sellersAdapter: IDataSourceAdapter<ISeller> = {
    fetchRecords: fetchSellers,
    createRecord: createSeller,
    updateRecord: updateSeller,
    deleteRecord: deleteSeller
};

export const agencyBiddersAdapter: IDataSourceAdapter<IBidder, IAgencyBiddersFilter> = {
    fetchRecords: fetchAgencyBidders,
    updateRecord: updateBidder,
    createRecord: createBidder,
    copyRecord: copyBidder,
    deleteRecord: deleteBidder
};

export const sellerSourcesAdapter: IDataSourceAdapter<ISource, ISellerSourcesFilter> = {
    fetchRecords: fetchSellerSources,
    updateRecord: updateSource,
    createRecord: createSource,
    deleteRecord: deleteSource
};

export const selfServeSellerSourcesAdapter: IDataSourceAdapter<any, ISellerSourcesFilter> = {
    fetchRecords: fetchSellerSources,
    updateRecord: updateLimitedSource
};

export const sellerBlockingsAdapter: IDataSourceAdapter<IBlocking, ISellerBlockingsFilter> = {
    fetchRecords: fetchSellerBlockings,
    updateRecord: updateBlocking,
    createRecord: createBlocking,
    deleteRecord: deleteBlocking
};

export const SellerFinanceAdapter: IDataSourceAdapter<IFinanceTransaction, ISellerFinanceFilter> = {
    fetchRecord: fetchSellerFinanceTransactions,
};

export const linesAdapter: IDataSourceAdapter<ILine> = {
  fetchRecords: (agencyId: number) => fetchLines(agencyId),
  createRecord: createLine,
  updateRecord: updateLine,
  deleteRecord: deleteLine,
};